import React from "react";
import Header from "../../Layout/Header/Header";
import Footer from "../../Layout/Footer/Footer";
import cancel from "../../../Assets/img/Group 2324.svg";

import uparrow from "../../../Assets/img/Path 1660.svg";
import downarrow from "../../../Assets/img/Path 1661.svg";

function Cart() {
  return (
    <div className="cart innerBody">
      <Header />
      <div className="container pt-4">
        <div className="row card-head">
          <div className="col">
            <div class="d-flex justify-content-between p-4 mt-auto mb-auto">
              <h3 className="pt-2">UNO PACK (1 Hint )</h3>
              <div className="position-relative">
                <input
                  type="number"
                  step="1"
                  max="99"
                  min="1"
                  value="1"
                  title="Qty"
                  class="qty"
                  size="4"
                />
                <div class="quantity">
                  <a href="/" class="plus">
                    <img src={uparrow} alt="" />
                  </a>
                  <a href="/" class="minus">
                    <img src={downarrow} alt="" />
                  </a>
                </div>
              </div>

              <div className="d-flex flex-nowrap">
                <h4 className="mr-3">$1.99</h4>
                <a href="/">
                  <img src={cancel} alt="" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="container mt-4 mb-5">
        <div className="row cart-form">
          <div className="col">
            <div className="card border-0">
              <div className="card-body">
                <h4>Billing Information</h4>
                <div class="row mt-3">
                  <div class="col-5">
                    <input
                      type="text"
                      class="form-control"
                      placeholder="Name *"
                    />
                  </div>
                  <div class="col-5 offset-1">
                    <input
                      type="text"
                      class="form-control"
                      placeholder="Display Name *"
                    />
                  </div>
                </div>
                <div class="row mt-5">
                  <div class="col-5">
                    <input
                      type="text"
                      class="form-control"
                      placeholder="Email Address *"
                    />
                  </div>
                  <div class="col-5 offset-1">
                    <input
                      type="text"
                      class="form-control"
                      placeholder="City *"
                    />
                  </div>
                </div>
                <div class="row mt-5 mb-5">
                  <div class="col-5">
                    <input
                      type="text"
                      class="form-control"
                      placeholder="Mobile *"
                    />
                  </div>
                  <div class="col-3 offset-1">
                    <input
                      type="text"
                      class="form-control"
                      placeholder="Captcha *"
                    />
                  </div>
                  <div class="col-2 ml-1">
                    <input
                      type="text"
                      class="form-control"
                      placeholder="55555"
                    />
                  </div>
                </div>
                <hr />
                <div className="row mt-4">
                  <div className="col text-center">
                    <button className="btn btn-yellow mr-4">
                      Pay with PayPal
                    </button>
                    <button className="btn btn-yellow mr-4">
                      Pay with citrus
                    </button>
                    <button className="btn btn-yellow mr-4">
                      Pay with billdesk
                    </button>
                    <a href="/level-page" className="btn btn-yellow">Cancel & Close</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Cart;
